import classNames from 'classnames';
import { Img, Portal, svgSprite } from '../../hybrid/wrappers';
import css from './EventsModal.module.scss';
import { useContext } from 'react';
import UserContext from '../../common/utils/getContext';
import T from '../../common/components/T';
import YoutubePlayer from '../youtubePlayer/YoutubePlayer';
import { getEventDuration } from '../../common/utils/utils';
import { LangContext } from '../../common/decorators/Language';
import Link from 'next/link';

export default function EventModal(props) {
    const { event, closeHandler, deleteEvent, showCreateEventModal } = props;
    const { lang } = useContext(UserContext);
    const { translation } = useContext(LangContext);

    const normalizedDateFirst = new Date(event?.event_date).toLocaleString(lang, { month: 'long', day: 'numeric' });
    const normalizedDateSecond = `(${new Date(event?.event_date)
        .toLocaleString(lang, { weekday: 'long', year: 'numeric' })
        ?.split(' ')
        ?.reverse()
        ?.join(', ')})`;

    return (
        <Portal
            closeHandler={closeHandler}
            customStyle={{
                wrapChildrenStyle: {
                    'overflow-x': 'scroll'
                }
            }}
        >
            <div className={css.modalWrapper}>
                {event.type_media === 'picture' ? (
                    <Img className={css.eventImage} src={event.picture?.links?.original} alt='Event' />
                ) : event.type_media === 'video' ? (
                    <video controls playsInline className={css.eventVideo} autoPlay>
                        <source src={event?.video?.links?.original} />
                    </video>
                ) : event.type_media === 'youtube' ? (
                    <div className={css.eventYoutube}>
                        <YoutubePlayer videoId={event?.youtube} />
                    </div>
                ) : null}
                <div className={classNames(css.modal, event.type_media !== 'nothing' && css.modalTopPad)}>
                    <div
                        onClick={closeHandler}
                        className={classNames('circleButton', css.closeButton, {
                            [css.closeButtonWhite]: event?.youtube || event?.video
                        })}
                    >
                        {svgSprite('cross', {
                            className: classNames(css.closeButtonSvg, { [css.closeButtonSvgWhite]: event.picture })
                        })}
                    </div>
                    <p className={css.title}>
                        <span className={css.titleFirst}>{normalizedDateFirst}</span>{' '}
                        <span className={css.titleSecond}>{normalizedDateSecond}</span>
                    </p>
                    <div className={css.line}></div>
                    <div className={css.field}>
                        <p className={css.fieldLabel}>
                            <T textName='duration' defaultStr='Длительность' />
                        </p>
                        <p className={css.fieldValue}>
                            {getEventDuration(event, translation, { format: 'HH:mm', returnObj: true }).allDay ? (
                                <span>
                                    <T textName='allDayEvent' defaultStr='Весь день' />
                                </span>
                            ) : (
                                <>
                                    <span>{getEventDuration(event, translation, { format: 'HH:mm', returnObj: true }).date}</span>
                                    <span> </span>
                                    <span>
                                        {getEventDuration(event, translation, { format: 'HH:mm', returnObj: true }).duration}
                                    </span>
                                </>
                            )}
                        </p>
                    </div>
                    <div className={css.line}></div>
                    <div className={css.field}>
                        <p className={css.fieldLabel}>
                            <T textName='event-description' defaultStr='Описание события' />
                        </p>
                        <p className={css.fieldValue}>{event?.description}</p>
                    </div>
                    <div className={css.line}></div>
                    <div className={css.field}>
                        <p className={css.fieldLabel}>
                            <T textName='event-link' defaultStr='Ссылка на событие' />
                        </p>
                        {event.link ? (
                            <Link target='_blank' className={css.fieldValue} href={event.link}>
                                {event.link}
                            </Link>
                        ) : (
                            <p className={css.fieldValue}>-</p>
                        )}
                    </div>
                    <div className={classNames(css.buttons, { [css.dn]: !event.can_edit })}>
                        <button onClick={() => deleteEvent(event)} className={classNames('circleButton', css.buttonDelete)}>
                            {svgSprite('trash-gt', { className: css.buttonSvg })}
                        </button>
                        <button
                            onClick={() => showCreateEventModal({ ...event, date: new Date(event?.event_date), id_edit: true })}
                            className={classNames('circleButton', css.buttonEdit)}
                        >
                            {svgSprite('pen', { className: css.buttonSvg })}
                        </button>
                    </div>
                </div>
            </div>
        </Portal>
    );
}
